const { Fragment, useState } = wp.element;

import AnalyticsAuth from './auth';
import Historical from './historical';
import Realtime from './realtime';

const CSS = {
  tab: {
    display: 'flex',
    justifyContent: 'start',
    marginBottom: '10px',
    boxSizing: 'border-box',
    borderRadius: '10px;'
  },
  tabItem: {
    padding: '2px 10px',
    marginRight: '5px',
    color: 'white',
    cursor: 'pointer',
    background: '#64a9f1'
  },
  tabItemActive: {
    padding: '2px 10px',
    marginRight: '5px',
    color: 'white',
    cursor: 'pointer',
    background: '#007cba'
  }
};

const Menu = (props) => {
  const { tab, setTab, busy } = props;
  return (
    <div style={CSS.tab}>
      <div style={tab === 'historical' ? CSS.tabItemActive : CSS.tabItem} onClick={() => setTab('historical')}>Historical</div>
      <div style={tab === 'realtime' ? CSS.tabItemActive : CSS.tabItem} onClick={() => setTab('realtime')}>Realtime</div>
      {busy && <span className="spinner" style={{ textAlign: 'right', flex: 1, visibility: 'visible', margin: '1px 0px', backgroundPosition: 'right' }} />}
    </div>
  );
}

const Dashboard = () => {
  const [ busy, setBusy ] = useState(false);
  const [ viewId, setViewId ] = useState();
  const [ tab, setTab ] = useState('historical');

	return (
    <Fragment>
      <Menu tab={tab} setTab={setTab} busy={busy} />
      <Fragment>
        <Historical visible={tab === 'historical'} viewId={viewId} onUpdate={() => setBusy(true)} onUpdated={() => setBusy(false)} />
        <Realtime visible={tab === 'realtime'} viewId={viewId} />
      </Fragment>
      <AnalyticsAuth onSignIn={(viewId) => setViewId(viewId)} onSignOut={() => setViewId(null)} />
    </Fragment>
  );
}

export default Dashboard;